import React, { FC } from 'react'
import cn from 'classnames'

export type TagType =
  | 'basic'
  | 'yellow'
  | 'transparent'
  | 'capital'
  | 'cost'
  | 'opportunity'
  | 'country'
  | 'date'
  | 'map'
  | 'mapPressed'
  | 'white'
  | 'imgBlue'
  | 'gray'
  | 'black'
  | 'lightGreen'

export type TagTypeWithStyle = Extract<
  TagType,
  'basic' | 'yellow' | 'transparent' | 'map' | 'mapPressed' | 'white' | 'imgBlue' | 'gray' | 'black' | 'lightGreen'
>

interface Props {
  type?: TagTypeWithStyle
  className?: string
}

const Tag: FC<Props> = ({ children, type = 'basic', className = '' }) => {
  const tagTypes: { [key in TagTypeWithStyle]: string } = {
    basic: 'gold',
    yellow: 'yellow',
    transparent: 'transparent',
    map: 'mapblue',
    mapPressed: 'darkblue',
    white: 'white',
    imgBlue: 'imgBlue',
    gray: 'gray',
    black: 'black',
    lightGreen: 'lightGreen'
  }

  return (
    <span
      className={cn(
        'parag--sm tag-bg',
        `tag-bg--${tagTypes[type]}`,
        { 'tag-bg--row': type === 'transparent' },
        className
      )}
    >
      {children}
    </span>
  )
}

export default Tag
